import React from 'react';
import {
  Helmet,
  HelmetProvider as ReactHelmetProvider,
} from 'react-helmet-async';

const ONETRUST_SCRIPT_DOMAIN = process.env.REACT_APP_ONETRUST_SCRIPT_DOMAIN;
const ONETRUST_GUID = process.env.REACT_APP_ONETRUST_GUID;
const IS_NON_PROD = process.env.REACT_APP_ENVI !== 'production';

interface HelmetProviderProps {
  children: React.ReactNode;
}

/**
 * Injects the OneTrust consent script into the document <head> via react-helmet-async.
 * The script sets window.OnetrustActiveGroups and shows the OneTrust banner automatically.
 */
export const HelmetProvider = ({ children }: HelmetProviderProps) => (
  <ReactHelmetProvider>
    <Helmet>
      <script
        async
        src={`https://${ONETRUST_SCRIPT_DOMAIN}/assets/atl-onetrust-wrapper.min.js`}
        type="text/javascript"
        data-domain={ONETRUST_GUID}
        data-test={IS_NON_PROD}
        data-geofence="false"
        data-sync="true"
      />
    </Helmet>
    {children}
  </ReactHelmetProvider>
);
